import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { CircleCheck, Info, CircleX, CircleAlert, OctagonAlert, TriangleAlert } from 'lucide-react';

import './Alert.scss';

export default function Alert({ show = false, message = '', type = 'success', setShowAlert = () => {} }) {
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShowAlert({ show: false, message: '', type: '' });
      }, 5000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CircleCheck className="alertIcon" />;
      case 'info':
        return <Info className="alertIcon" />;
      case 'warning':
        return <TriangleAlert className="alertIcon" />;
      case 'error':
        return <OctagonAlert className="alertIcon" />;
      default:
        return <CircleAlert className="alertIcon" />;
    }
  };

  return (
    <div className={`alertWrapper ${show ? 'visible' : 'hidden'}`}>
      <div
        className={`alertContainer ${type}`}
        role="alert"
      >
        <div className="alertContent">
          {getIcon()}
          <p className="alertMessage">{message}</p>
        </div>

        <div className="alertCloseButton" onClick={() => setShowAlert(false)}>
          <CircleX className="closeIcon" color='#fff' />
        </div>
      </div>
    </div>
  );
};

Alert.propTypes = {
  show: PropTypes.bool,
  message: PropTypes.string,
  type: PropTypes.oneOf(['success', 'info', 'warning', 'error', ""]),
  setShowAlert: PropTypes.func,
};
